import { useState } from 'react';
import { faqs } from '@/mocks/comics';

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="w-full py-12 md:py-16 bg-background-100">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-1">
          <p className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-question-line"></i>
            常见问题
          </p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">使用前了解一下</h2>
          <p className="mt-3 text-foreground-600 text-sm leading-relaxed">
            关于4399漫画网的分类浏览、完结作品库、热门排行与搜索功能，以下常见问题可以帮你快速上手，找到最合口味的漫画。
          </p>
          <div className="mt-6 p-5 rounded-2xl bg-secondary-500 text-background-50">
            <p className="font-medium mb-1">还有疑问？</p>
            <p className="text-sm text-background-50/85">欢迎通过页脚的联系方式或留言表单与我们取得联系。</p>
          </div>
        </div>

        <div className="lg:col-span-2 flex flex-col gap-3">
          {faqs.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className={`rounded-xl border bg-background-50 transition-colors ${
                  isOpen ? 'border-primary-200' : 'border-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="font-medium text-foreground-950 text-sm md:text-base">{item.q}</h3>
                  <span
                    className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                    }`}
                  >
                    <i className={`ri-${isOpen ? 'subtract-line' : 'add-line'}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-4 md:px-5 pb-4 text-sm text-foreground-700 leading-relaxed border-t border-background-100 pt-3">
                    {item.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}